import FormSectionContainer from "../../components/Form/FormSectionContainer";
import FormSectionTitle from "../../components/styled/FormSectionTitle";

import { useGetAllUserAsDropdown } from "../../utils/user.utils";

export default function ReceiverField({ watch, control, errors, setValue }) {
  const { data: receivers, loading } = useGetAllUserAsDropdown(``);

  const fields = [
    {
      label: "Name",
      name: "receiver.name",
      type: "select",
      placeholder: "Select a name",
      col: { md: 4 },
      options: receivers ?? []
    }
  ];

  const isLoading = loading;

  return (
    <>
      <FormSectionContainer
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        loading={isLoading}>
        <div className="col-12">
          <FormSectionTitle>Receiver Information</FormSectionTitle>
        </div>
      </FormSectionContainer>
    </>
  );
}
